module.exports = __webpack_public_path__ + "img/builder-14.83592ec4.webp";